import curry from "../../../lib/core/functional/curry";

const renderModule = curry(function renderModule(preact, _context, deps, _altLoader) {
    const { raiseNotification } = deps;
    const { h, hooks } = preact;

    const { useCallback, useEffect } = hooks;
    function Module(props) {
        const { isLoggedIn, disabled, success, isInFolder, onClick } = props;

        useEffect(() => {
            if (success === null) {
                return;
            }

            if (success === true) {
                const message = isInFolder ? "Post saved in folder" : "Post removed from folder";
                raiseNotification(message, "success");
            } else if (success === false) {
                raiseNotification("There has been an error", "error");
            }
        }, [success, isInFolder]);

        const _onClick = useCallback(
            function _onClick() {
                if (disabled || !isLoggedIn) {
                    return;
                }

                onClick();
            },
            [disabled, onClick, isLoggedIn]
        );

        if (isInFolder === null) {
            return null;
        }

        let buttonClass;
        if (success === true) {
            buttonClass = " rm-folders-success";
        } else if (success === false) {
            buttonClass = " rm-folders-error";
        } else {
            buttonClass = "";
        }

        return (
            <a
                onClick={_onClick}
                class={`rm-folders-toggle-post-in-folder rm-folders-${
                    isInFolder ? "in-folder" : "not-in-folder"
                }${buttonClass}${disabled ? " rm-folders-disabled" : ""}`}
                href={isLoggedIn ? "javascript:;" : "/login"}
                ariaLabel={isInFolder ? "Remove from folder" : "Add to folder"}
            >
                <i class={`fa ${isInFolder ? "fa-minus" : "fa-plus"}`}></i>
            </a>
        );
    }
    return Module;
});

export default function folderModule({ preact }) {
    return renderModule(preact);
}
